/** Grid cursor movement with wrap-around; the last row may be short. */
export function wrapIndex(i: number, n: number, dx: number, dy: number, cols: number): number {
  if (n <= 0) return 0;
  const rows = Math.ceil(n / cols);
  let col = i % cols;
  let row = Math.floor(i / cols);
  col = (col + dx + cols) % cols;
  row = (row + dy + rows) % rows;
  let next = row * cols + col;
  if (next >= n) next = n - 1;
  return next;
}
